import { render, staticRenderFns } from "./bussinessInfo.vue?vue&type=template&id=e7455474&scoped=true&"
import script from "./bussinessInfo.vue?vue&type=script&lang=js&"
export * from "./bussinessInfo.vue?vue&type=script&lang=js&"
import style0 from "./bussinessInfo.vue?vue&type=style&index=0&id=e7455474&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7455474",
  null
  
)

export default component.exports